import { navigateToStep, ApplicationPaths } from '@n2-common/applicationPages/ApplicationFormsHelpers';
import { ApplicationStatusModel } from '@n2-common/serverGeneratedTypings/applicationStatusModel';
import { N2Product } from '@n2-common/serverGeneratedTypings/n2Product';
import { createHashRouter, NavigateFunction, RouterProvider } from 'react-router-dom';
import { PageLayout } from '@n2-common/applicationPages/AppBase/AppBase';
import {
    ApplicantActionsCompletedPage,
    CanceledPage,
    CddPage,
    CompletedPage,
    ErrorPage,
    InProgressPage,
    InsurancePage,
    LoadApplicationPage,
    NotFoundPage,
    ReactRouterErrorBoundary,
    SblCompleted,
} from '@n2-common/applicationPages/';
import DeclinedPage from '@n2-common/applicationPages/DeclinedPage';
import { SignCompletedPage } from '../../common/applicationPages/SignCompleted';
import WizardApp from './pages/LoanApplicationWizard/LoanApplicationWizard';
import { Offer } from './pages/Offer/Offer';
import { commonNavigateToCorrectStepForSingleApplicantProducts } from '@n2-common/applicationPages/applicationStatusHelpers';
import { NorwegianLoanPPiInfo } from './components/Insurance/Insurance';
import { Sign } from './pages/Sign/Sign';
import { SetAccountNumber } from './pages/Sign/SetAccountNumber';
import { UploadDocumentsPage } from '../../common/applicationPages/UploadDocuments';
import { afterCddFuncForPpiProducts } from '@n2-common/applicationPages/CddPage';
import DeclinedWithLinkPage from '../../common/applicationPages/DeclinedWithLink';
import { AreYouSureYouDoNotWantPpiBox } from '@n2-common/applicationPages/InsurancePage';
import { Channel } from '@n2-common/serverGeneratedTypings/channel';

export const navigateToCorrectStep = (application: ApplicationStatusModel, applicantId: string, navigate: NavigateFunction) => {
    if (application.Product !== N2Product.Loan) {
        console.log('product is not Loan, navigating to notfound');
        navigateToStep(ApplicationPaths.notFound, application.ApplicationId, navigate, applicantId);
        return;
    }

    return commonNavigateToCorrectStepForSingleApplicantProducts(application, applicantId, navigate);
};

export const App = ({ antiforgeryToken }: { antiforgeryToken: string | undefined }) => {
    const loanNoRouter = createHashRouter([
        {
            element: <PageLayout productType="CLA" channel={Channel.Web} country="NO" antiforgeryToken={antiforgeryToken} versionApp="" />,
            children: [
                {
                    path: ApplicationPaths.wizard,
                    element: <WizardApp />,
                },
                {
                    path: ApplicationPaths.offer,
                    element: <Offer />,
                },
                {
                    path: ApplicationPaths.cdd,
                    element: <CddPage product={'loan'} afterCddFunc={afterCddFuncForPpiProducts} navigateToCorrectStepFunc={navigateToCorrectStep} />,
                },
                {
                    path: ApplicationPaths.sign,
                    element: <Sign />,
                },
                {
                    path: ApplicationPaths.signCompleted,
                    element: <SignCompletedPage navigateToCorrectStepFunc={navigateToCorrectStep} />,
                },
                {
                    path: ApplicationPaths.uploadDocuments,
                    element: <UploadDocumentsPage navigateToCorrectStepFunc={navigateToCorrectStep} />,
                },
                {
                    path: ApplicationPaths.setAccountNumber,
                    element: <SetAccountNumber />,
                },
                {
                    path: ApplicationPaths.insurance,
                    element: (
                        <InsurancePage
                            navigateToCorrectStepFunc={navigateToCorrectStep}
                            areYouSureYouDoNotWantPpiBox={<AreYouSureYouDoNotWantPpiBox />}
                        >
                            <NorwegianLoanPPiInfo />
                        </InsurancePage>
                    ),
                },
                {
                    path: ApplicationPaths.declined,
                    element: <DeclinedWithLinkPage navigateToCorrectStepFunc={navigateToCorrectStep} />,
                },
                {
                    path: ApplicationPaths.declinedFromAgent,
                    element: <DeclinedPage navigateToCorrectStepFunc={navigateToCorrectStep} />,
                },
                {
                    path: ApplicationPaths.canceled,
                    element: <CanceledPage navigateToCorrectStepFunc={navigateToCorrectStep} />,
                },
                {
                    path: ApplicationPaths.completed,
                    element: <CompletedPage navigateToCorrectStepFunc={navigateToCorrectStep} />,
                },
                {
                    path: ApplicationPaths.applicantActionsCompleted,
                    element: <ApplicantActionsCompletedPage navigateToCorrectStepFunc={navigateToCorrectStep} />,
                },
                {
                    path: ApplicationPaths.error,
                    element: <ErrorPage />,
                },
                {
                    path: ApplicationPaths.notFound,
                    element: <NotFoundPage navigateToCorrectStepFunc={navigateToCorrectStep} />,
                },
                {
                    path: ApplicationPaths.inProgress,
                    element: <InProgressPage navigateToCorrectStepFunc={navigateToCorrectStep} />,
                },
                {
                    path: ApplicationPaths.loadApplication,
                    element: <LoadApplicationPage navigateToCorrectStepFunc={navigateToCorrectStep} />,
                },
                {
                    path: ApplicationPaths.sblCompleted,
                    element: <SblCompleted navigateToCorrectStepFunc={navigateToCorrectStep} />,
                },
            ],
            errorElement: <ReactRouterErrorBoundary />,
        },
    ]);
    return (
        <>
            <RouterProvider router={loanNoRouter} />
        </>
    );
};
